module.exports = __webpack_public_path__ + "static/media/Santísimo_Sacramento.0f68872c.jpg";